import { __awaiter } from "tslib";
import { RowType } from '@getaccept/editor-lib-new';
import { ref, computed, defineComponent } from 'vue';
import VerifySignature from '@getaccept/lib-shared-new/src/signing/components/VerifySignature.vue';
import { ModalSize } from '@getaccept/fried-tofu';
import { SignatureHelper } from '@getaccept/editor-lib-new/src/helpers/signature.helper';
import EditorNodeWrapper from './EditorNodeWrapper.vue';
import SignatureItem from './SignatureItem.vue';
export default defineComponent({
    name: 'EditorNodeSignature',
    components: {
        EditorNodeWrapper,
        SignatureItem,
        VerifySignature,
    },
    props: {
        node: { type: Object, default: () => ({}) },
        mergeValues: { type: Object, required: true },
        rowType: { type: String, default: RowType.Standard },
        parentFirstChild: { type: Boolean, default: false },
        parentLastChild: { type: Boolean, default: false },
        blockWidthClass: { type: String, default: null },
        recipient: { type: Object, default: () => ({}) },
        sender: { type: Object, default: () => ({}) },
        focusedRequiredId: { type: String, default: null },
        partiallySignedFields: { type: Array, default: () => [] },
        context: { type: String, default: null },
        isPdfViewer: { type: Boolean, default: false },
    },
    emits: ['observe-node-visibility', 'partially-sign'],
    setup(props, { emit }) {
        const rowTypeClass = computed(() => { var _a; return `row-type-${(_a = props.rowType) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`; });
        const showSignatureModal = ref(false);
        const isLoadingSignature = ref(false);
        const getVisibleSignatures = computed(() => SignatureHelper.getVisibleFields(props.node.fields));
        const handleVerifySignature = ({ signatureBase64, signatureBase30 }) => __awaiter(this, void 0, void 0, function* () {
            showSignatureModal.value = false;
            isLoadingSignature.value = true;
            emit('partially-sign', { signatureBase64, signatureBase30, nodeId: props.node.id });
        });
        const handleShowSignatureModal = () => {
            if (!props.recipient.signature) {
                showSignatureModal.value = true;
                return;
            }
            handleVerifySignature({
                signatureBase64: props.recipient.signature,
                signatureBase30: {},
            });
        };
        return {
            rowTypeClass,
            getVisibleSignatures,
            handleShowSignatureModal,
            showSignatureModal,
            handleVerifySignature,
            ModalSize,
            isLoadingSignature,
        };
    },
});
